import React, { Component } from "react";
import Select from "react-select";
import chroma from "chroma-js";
import COLORS from "scss/colors.module.scss";
import { Chip } from "@material-ui/core";

export default class MultiselectColumnEditor extends Component {
  constructor(props) {
    super(props);
    var options = [];
    var columnOptions = props.colDef?.cellRendererParams?.columnOptions;
    columnOptions.options.map((option, index) => {
      options.push({
        value: typeof option == "string" ? option.trim() : option,
        label: typeof option == "string" ? option.trim() : option,
        color: COLORS.PRIMARY_COLOR,
        background: columnOptions.colors?.[index] || "grey",
      });
      return 0;
    });

    this.state = {
      searchInput: this.props.charPress ? this.props.charPress : "",
      options: options,
      selectedOption: props.value,
      top: false,
      bottom: false,
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(
      this
    );
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleChange = (
    selectedOption,
    enterClicked = false,
    isCloseRequested = false
  ) => {
    var data = [];
    if (selectedOption) {
      selectedOption.map((option) => {
        data.push(option.label);
        return 0;
      });
    }
    var value = enterClicked
      ? (this.state.selectedOption ?this.state.selectedOption + ", " :"") + data.join(", ")
      : data.join(", ");
    this.props.onChange(value);
    this.setState(
      {
        selectedOption: value,
        searchInput: ""
      },
      () => {
        if (isCloseRequested) {
          this.props.api.stopEditing();
        }
      }
    );
  };

  componentDidMount() {
    this.refs.container.addEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    this.focus();
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  arrowKeyNavigation = (event) => {
    if (
      [13].indexOf(event.keyCode) > -1 &&
      this.refs.selectRef.select.state.focusedOption
    ) {
      event.stopPropagation();
      if (event.shiftKey) {
        this.props.api.stopEditing(false);
        this.props.api.setFocusedCell(
          this.props.rowIndex,
          this.props.column.colId
        );
      } else {
        var temp = [];
        temp.push(this.refs.selectRef?.select?.state?.focusedOption);
        this.handleChange(temp, true);
      }
    }
  };

  focus() {
    window.setTimeout(() => {
      if(this.refs.selectRef)
        this.refs.selectRef.focus();
      document.addEventListener("mousedown", this.handleClickOutside);
      if (this.refs.container && 
        window.innerHeight - this.refs.container.getBoundingClientRect().top <
        this.refs.container.getBoundingClientRect().height +  (this.props.colDef.store.isSubsheet ? 160 : 40)
      ) {
        this.setState({
          top: null,
          bottom: 1,
        });
      } else {
        this.setState({
          top: this.props.node.rowHeight,
          bottom: null,
        });
      }
    });
  }
  getValue() {
    return this.state.selectedOption;
  }

  isPopup() {
    return true;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.props.api.stopEditing(false);
    }
  }

  colourStyles = {
    control: (styles) => ({
      ...styles,
      minWidth: this.props.colDef.width,
      margin: 8,
    }),
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const background = data.background==="transparent"? chroma("grey") :chroma(data.background);
      return {
        ...styles,
        minHeight: 32,
        display: "flex",
        alignItems: "center",
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? data.background
          : isFocused
          ? background.alpha(0.1).css()
          : null,
        color: isDisabled
          ? COLORS.DISABLED_MENU_OPTION
          : isSelected
          ? chroma.contrast(background, COLORS.PRIMARY_COLOR) > 2
            ? COLORS.PRIMARY_COLOR
            : COLORS.SECONDARY_COLOR
          : data.background,
        cursor: isDisabled ? "not-allowed" : "default",
  
        ":active": {
          ...styles[":active"],
          backgroundColor:
            !isDisabled &&
            (isSelected ? data.background : background.alpha(0.3).css()),
        },
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: data.background,
        borderRadius: 20,
        padding: 3,
      };
    },
    multiValueLabel: (styles, { data }) => {
      return {
        ...styles,
        color: COLORS.PRIMARY_COLOR,
      };
    },
    multiValueRemove: (styles, { data }) => {
      const background = chroma(COLORS.PRIMARY_COLOR);
      return {
        ...styles,
        color: data.background,
        backgroundColor: background.alpha(0.7).css(),
        cursor: "pointer",
        borderRadius: 20,
        padding: 0,
        height: 16,
        width: 16,
        alignSelf: "center",
        justifyContent: "center",
        ":hover": {
          backgroundColor: COLORS.PRIMARY_COLOR,
        },
        // display: "none", //to hide 'x' for each option
      };
    },
  };

  onSearchInputChange=(text)=>{
    this.setState({searchInput: text})
  }

  render() {
    let rootStyle = {
      background: "white",
      display: "inline-block",
      visibility: this.state.top || this.state.bottom ? "visible" : "hidden",
      position: "absolute",
      top: this.state.top,
      bottom: this.state.bottom,
      boxShadow: "4px 4px 10px #aaa",
    };
    var values = this.state.selectedOption
      ? this.state.selectedOption.split(",")
      : [];
    var valuesArrToShow = [],
      temp;
    values.map((value) => {
      temp = this.state.options.find((option) => option.label === value.trim());
      if (temp) {
        valuesArrToShow.push(temp);
      } else if (value) {
        value = typeof value == "string" ? value.trim() : value;
        let opt = {
          label: value,
          value: value,
          color: "#ffffff",
          background: "grey",
        };
        valuesArrToShow.push(opt);
      }
      return 0;
    });
    return (
      <div ref={this.setWrapperRef}>
        <div ref="container" style={rootStyle}>
          <Select
            ref="selectRef"
            value={valuesArrToShow}
            onChange={(selectedOption) =>
              this.handleChange(selectedOption, false)
            }
            // defaultInputValue={this.props.charPress ? this.props.charPress : ""}
            inputValue={this.state.searchInput}
            onInputChange={this.onSearchInputChange}
            options={this.state.options}
            menuIsOpen={true}
            formatOptionLabel={(props) => (
              <OptionFormatter
                {...props}
                rowHeight={this.props.node.rowHeight}
              />
            )}
            placeholder="Find an option.."
            closeMenuOnSelect={false}
            backspaceRemovesValue={true}
            isMulti={true}
            styles={this.colourStyles}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: null,
            }}
            maxMenuHeight="25vh"
          />
          <div className="multiLineExtraText">Shift+Enter or Tab to save</div>
        </div>
      </div>
    );
  }
}

const OptionFormatter = ({
  value,
  label,
  color,
  background,
  rowHeight,
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
    }}
  >
    {/* {label} */}
    <Chip
      label={label}
      style={{
        backgroundColor: background,
        color: color,
      }}
      size="small"
      // size={rowHeight < DIMENSIONS.cell_height_medium ? "small" : "medium"}
    />
  </div>
);
